import { Component } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import withRouter from './../helper/withrouter';
import Home from './Homepage/Homepage';

class App extends Component{
  constructor(){
    super();
    
    this.state = {
      utm: '',
    }
    
    // this.cancellableLead = '';

    // this.selectRegion = this.selectRegion.bind(this);
  }

  componentDidMount(){
    const param = this.props.router.search[0];
    
    if(param){
      const source = param.get('utm_source'),
            medium = param.get('utm_medium');

      let utmVal = '?';

      if(source && medium){
        utmVal = utmVal + `utm_source=${source}&utm_medium=${medium}`;
      }else{
        if(source){
          utmVal = utmVal + `utm_source=${source}`;
        }else if(medium){
          utmVal = utmVal + `utm_medium=${medium}`;
        }
      }

      this.setState({ utm: utmVal });
    }
  }

  componentDidUpdate(prevProps, prevState){}

  componentWillUnmount(){}

  render(){

    return(
      <Routes>
        <Route exact path="/" element={<Navigate to={`/pricing${this.state.utm}`} />} />
        <Route path="*" element={<Navigate to={`/pricing${this.state.utm}`} />} />
        
        <Route path="/pricing" element={<Home />} />
      </Routes>
    );
  }
}

export default withRouter(App);